/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Environment } from '../models/Environment';
import { FileSnapshot } from '../models/FileSnapshot';
import { Provider } from '../models/Provider';
import { ResourceType } from '../models/ResourceType';
import { SecurityInformation } from '../models/SecurityInformation';

export class FileSearchRecord {
  /**
  * The resource ID, containing the file
  */
  'resourceId': string;
  /**
  * The provider resource ID of the resource
  */
  'providerResourceId': string;
  /**
  * The name of the resource
  */
  'resourceName': string;
  'resourceType'?: ResourceType;
  /**
  * The path of the file
  */
  'path': string;
  /**
  * The type of the path (file - \'f\' or directory - \'d\' or symlink - \'l\')
  */
  'type': string;
  'environment'?: Environment;
  'cloudProvider'?: Provider;
  /**
  * The apps associated with the resource
  */
  'apps'?: Array<string>;
  /**
  * The tags of the volume
  */
  'tags'?: { [key: string]: string; };
  /**
  * The snapshots of the file
  */
  'snapshots': Array<FileSnapshot>;
  'securityInformation'?: SecurityInformation;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceId",
      "baseName": "resourceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerResourceId",
      "baseName": "providerResourceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceName",
      "baseName": "resourceName",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceType",
      "baseName": "resourceType",
      "type": "ResourceType",
      "format": ""
    },
    {
      "name": "path",
      "baseName": "path",
      "type": "string",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "string",
      "format": ""
    },
    {
      "name": "environment",
      "baseName": "environment",
      "type": "Environment",
      "format": ""
    },
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "apps",
      "baseName": "apps",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "snapshots",
      "baseName": "snapshots",
      "type": "Array<FileSnapshot>",
      "format": ""
    },
    {
      "name": "securityInformation",
      "baseName": "securityInformation",
      "type": "SecurityInformation",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return FileSearchRecord.attributeTypeMap;
  }

  public constructor() {
  }
}



